import { Model } from './model';
import { Expose } from 'class-transformer';
import { ColorPerTheme, Themes } from '@shared-features/enums/layout.enum';

export class Theme extends Model {
  @Expose() id: number;
  @Expose() themeName: Themes;
  @Expose() color: ColorPerTheme;
  @Expose() createdAt: Date;
  @Expose() updatedAt: Date;
  @Expose() imageUrl: string;
  @Expose() mediaId: number;
}
